import { MaskedInput } from 'antd-mask-input';
import React from 'react';

export const DynamicPhone = (props) => {
    const cellphoneMask = "(00) 0 0000-0000";
    const phoneMask = "(000) 000-0000";

    // always memoize dynamic masks
    const mask = React.useMemo(
      () => [
        {
          mask: cellphoneMask,
          lazy: false,
        },
        {
          mask: phoneMask,
          lazy: false,
        },
      ],
      []
    );

    return (
      <MaskedInput
        {...props}
        mask={mask}
        maskOptions={{
          dispatch: function (appended, dynamicMasked) {
            const isCellPhone = dynamicMasked.unmaskedValue[2] === "9";
            return dynamicMasked.compiledMasks[isCellPhone ? 0 : 1];
          },
        }}
      />
    );
  };
